(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  function fixHelpHeadingContrast() {
    var nodes = document.querySelectorAll('h1,h2,h3,h4,h5,h6,p,strong,span');
    for (var i = 0; i < nodes.length; i++) {
      var text = (nodes[i].textContent || '')
        .replace(/[’‘]/g, "'")
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase();
      if (text.indexOf("BESOIN D'AIDE") !== -1) {
        nodes[i].classList.add('eaz-help-contrast-fix');
      }
    }
  }

  fixHelpHeadingContrast();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixHelpHeadingContrast);
  }

  var observer = new MutationObserver(function () {
    fixHelpHeadingContrast();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(function () { observer.disconnect(); }, 12000);
})();

  } catch(e) { console.error(e); }
})();
})();
